import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import env from '../../env';
import { createStructuredSelector } from 'reselect';
import { getImgUrlExterior } from '../../modules/Vehicles/helpers';
import { BaseComponent } from '../BaseComponent';
import { Modal } from '../Modal';
import 'react-responsive-carousel/lib/styles/carousel.min.css'; // requires a loader
import { Carousel } from 'react-responsive-carousel';
import { getDocumentsWebloginByType } from '../../modules/Weblogin/actions';
import { getDocumentsByType } from '../../modules/Vehicles/actions';
import { selectWork } from '../../modules/Api/selectors';
import { REQUEST_VEHICLE_DOCUMENTS_BY_TYPE } from '../../modules/Vehicles/constants';
import { Loader } from '../Loader';
import cn from 'classnames';
const Container = styled.div`
  min-width: 150px;
  max-width: 150px;
  min-height: 70px;
  margin: 6px;
  .avatarImg {
    max-width: 100%;
    height: auto;
  }

  @media (max-width: 768px) {
    width: 300px;
    height: 160px;
  }
  @media (max-width: 450px) {
    width: 150px;
    height: 80px;
  }

  position: relative;

  .img {
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center center;
    width: 150px;
    height: 85px;
    position: absolute;
  }
`;

const STATE = {
  showCarousel: false,
};

class VehicleAvatarSliderComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {
    this.props.getPhotos(result => {
      if (result?.length) {
        this.setState({ carouselImages: result });
      }
    });
  }

  renderPhotoCarousel = () => {
    return (
      <Modal onClose={this.closeCarousel} title={this.lbl('interior.inspection.photos')}>
        <Carousel
          showArrows={true}
          infiniteLoop
          showThumbs={false}
          showIndicators={false}
          showStatus={false}
          autoPlay={false}
        >
          {this.state.carouselImages?.map(image => (
            <div key={image?.id}>
              <img src={image?.url} alt="Vehicle damage image" />
            </div>
          ))}
        </Carousel>
      </Modal>
    );
  };

  openCarousel(e) {
    e.stopPropagation();

    this.setState({ showCarousel: true });
  }

  closeCarousel = () => {
    this.setState({ showCarousel: false });
  };

  render() {
    if (this.props.work) return <Loader small />;
    return (
      <Container className="avatar" vehicle={this.props.vehicle}>
        {this.state.showCarousel && this.renderPhotoCarousel()}
        
        
        {env.disable_SIRV ? (
  <div
    onClick={e => (!this.props.withoutSlide ? this.openCarousel(e) : this.props.onClick())}
    className="img bottom"
    style={{
      backgroundImage: this.state.carouselImages?.length  
      ? `url('${this.state.carouselImages[0]?.url}')` : this.props.vehicle?.HOOI_inslag_done_date != null ? `url('/public/images/hooikammer_inslag.png')` 
      : `url('/public/images/placeholder.png')`,
    }}
  ></div>
) : (
  <div
    className="img bottom"
    style={{
      backgroundImage: this.props.vehicle?.HOOI_inslag_done_date != null 
        ? `url('/public/images/hooikammer_inslag.png')` 
        : `url('${getImgUrlExterior(this.props.vehicle?.helga_id || this.props.vehicle?.id, '01')}'), url('/public/images/placeholder.png')`,
    }}
  ></div>
)}

        {env.disable_SIRV ? (
          <div
            onClick={e => (!this.props.withoutSlide ? this.openCarousel(e) : this.props.onClick())}
            className={cn('img bottom', this.props.className)}
            style={{
              backgroundImage: `url('${this.state.carouselImages?.length &&
                encodeURI(decodeURI(this.state.carouselImages[0]?.url)).replace(
                  /%5C/g,
                  '/',
                )}'), url('/public/images/placeholder.png`,
            }}
          ></div>
        ) : (
          <div
            className="img bottom"
            style={{
              backgroundImage: `url('${getImgUrlExterior(
                this.props.vehicle?.helga_id || this.props.vehicle?.id,
                '01',
              )}'), url('/public/images/placeholder.png')`,
            }}
          ></div>
        )}
      </Container>
    );
  }
}

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWork(`${REQUEST_VEHICLE_DOCUMENTS_BY_TYPE}-${ownProps.vehicle?.id}`),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    getPhotos(callback) {
      if (ownProps.weblogin) {
        dispatch(getDocumentsWebloginByType(ownProps.vehicle?.id, 'photo_hooi_hooi_instalation', callback));
      } else {
        dispatch(getDocumentsByType(ownProps.vehicle?.id, 'photo_hooi_hooi_instalation', callback));
      }
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const VehicleAvatarSlider = compose(withConnect, withRouter)(VehicleAvatarSliderComp);
